import { Component, OnInit, OnChanges, Input, SimpleChanges } from '@angular/core';
import { EmailTemplateReportService } from '../../../../../services/email-template/email-template-report.service';
import { NgxPermissionsService } from 'ngx-permissions';
import { globalValues } from '../../../../globals';
import * as _ from 'lodash';

@Component({
  selector: 'app-email-sent-by-template-widget',
  templateUrl: './email-sent-by-template-widget.component.html',
  styleUrls: ['./email-sent-by-template-widget.component.scss']
})
export class EmailSentByTemplateWidgetComponent implements OnInit, OnChanges {
  @Input() relativeDate: any;
  @Input() campaignData: any;

  public isLoaded = false;
  public chartData: any = {
    labels: [],
    datasets: []
  };

  constructor(
    private emailTemplateReportService: EmailTemplateReportService,
    private permissionService: NgxPermissionsService
  ) {}

  ngOnInit() {
    if (this.permissionService.hasPermission('emailtemplates:can_get_emailtemplates_reports_sent')) {
      this.loadChartData();
    }
  }

  ngOnChanges(changes: SimpleChanges) {
    if (this.permissionService.hasPermission('emailtemplates:can_get_emailtemplates_reports_sent')) {
      if (changes['relativeDate'] && !changes['relativeDate'].isFirstChange()) {
        this.loadChartData();
      }
      if (changes['campaignData'] && !changes['campaignData'].isFirstChange()) {
        this.loadChartData();
      }
    }
  }

  loadChartData() {
    const criteriaArray = this.buildCriteria();
    this.isLoaded = false;

    this.emailTemplateReportService.getSent(criteriaArray).subscribe((res: any) => {
      if (res.success === 'true' && res.data) {
        this.transformDataForChart(res.data);
      }
      this.isLoaded = true;
    });
  }

  private buildCriteria() {
    const criteriaArray: any[] = [
      {
        is_required: true,
        criterion: 'dateRange',
        value: {
          relative_date: this.relativeDate
        }
      }
    ];

    if (this.hasCampaignFilter(this.campaignData)) {
      criteriaArray.push(this.buildCampaignCriterion(this.campaignData));
    }

    return criteriaArray;
  }

  private transformDataForChart(data: any[]) {
    // Group by category (template) and sum occurrences
    const groupedByTemplate = _.chain(data)
      .groupBy('category')
      .map((items, template) => ({
        template: template || 'Unknown Template',
        count: _.sumBy(items, 'number_of_occurrences')
      }))
      .orderBy(['count'], ['desc'])
      .take(10) // Top 10 templates
      .value();

    this.chartData = {
      labels: groupedByTemplate.map(d => d.template),
      datasets: [
        {
          label: 'Emails Sent',
          data: groupedByTemplate.map(d => d.count),
          backgroundColor: globalValues.chart_colors
        }
      ]
    };
  }

  private hasCampaignFilter(campaignData: any): boolean {
    return (
      campaignData !== null &&
      campaignData !== undefined &&
      campaignData !== '' &&
      campaignData !== 0 &&
      campaignData !== '0'
    );
  }

  private buildCampaignCriterion(campaignData: any) {
    return {
      id: '',
      value: { c_id: campaignData },
      criterion: 'campaign',
      is_required: true
    };
  }
}
